module.exports = __webpack_public_path__ + "static/caddy-maxivan-d3299b20eedb3f8dee4575afeeb1fa6d.png";